import { useEffect, useState } from "react";
import { http } from "../../lib/api";

const usd = (n) => `$${n.toFixed(2)}`;

export const CostByTier = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { http.get("/ops/cost-by-tier").then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  if (!rows.length) return <p data-testid="cost-by-tier-empty" className="mb-4 text-sm text-stone-500">No kit costs recorded yet.</p>;
  return (
    <div data-testid="cost-by-tier-panel" className="mb-6 overflow-x-auto rounded-lg border border-stone-200 bg-white">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-stone-500">
            <th className="px-4 py-2 font-normal">Kit type</th><th className="px-4 py-2 font-normal">Edition</th><th className="px-4 py-2 font-normal">Tier</th>
            <th className="px-4 py-2 text-right font-normal">Kits</th><th className="px-4 py-2 text-right font-normal">Average AI cost</th><th className="px-4 py-2 text-right font-normal">Range</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={`${r.type}-${r.edition}-${r.tier}`} data-testid={`cost-tier-row-${i}`} className="border-t border-stone-100">
              <td className="px-4 py-1.5">{r.type}</td><td className="px-4 py-1.5 capitalize">{r.edition}</td><td className="px-4 py-1.5">{r.tier}</td>
              <td className="px-4 py-1.5 text-right tabular-nums">{r.kits}</td>
              <td data-testid={`cost-tier-avg-${i}`} className={`px-4 py-1.5 text-right font-bold tabular-nums ${r.avg > 8 ? "text-red-700" : "text-[#2B2A26]"}`}>{usd(r.avg)}</td>
              <td className="px-4 py-1.5 text-right tabular-nums text-stone-500">{usd(r.min)} – {usd(r.max)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="px-4 py-2 text-xs text-stone-500">All-time AI cost per kit (writing, web research and images), bespoke kits excluded.</p>
    </div>
  );
};
